import { initI18n } from '@agos/shared'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './index.css'

// Before the first render. Without it `tt()` returns its argument, which happens to look right because
// the source strings are Slovak — so a missing `initI18n` is invisible until somebody switches language
// and nothing changes.
initI18n()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('index.html is missing the #root mount point')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
